import React, { Fragment, Suspense, useMemo } from "react";

import { type RendererProps } from "@atlaskit/renderer";

import { Source } from "../ai-summary";

import { encodeAdf } from "./encoder";

const AkReactRenderer = React.lazy(() =>
    import("@atlaskit/renderer").then(({ ReactRenderer }) => ({
        default: ReactRenderer
    }))
);

export type MarkdownRendererProps = {
    answerString: string;
    statusComponent: (props: {
        text?: string;
        sources?: Source[];
    }) => React.ReactNode;
};

const MediaComponent = () => <Fragment />;
const MediaSingleComponent = () => <Fragment />;

export const MarkdownRenderer = ({
    answerString,
    statusComponent
}: MarkdownRendererProps) => {
    const docContent = useMemo(
        () => encodeAdf(answerString, false),
        [answerString]
    );

    const config: RendererProps = {
        document: docContent,
        nodeComponents: {
            status: statusComponent,
            media: MediaComponent,
            mediaSingle: MediaSingleComponent
        },
        smartLinks: {
            ssr: true
        }
    };

    return (
        <Suspense fallback={<Fragment />}>
            <AkReactRenderer {...config} />
        </Suspense>
    );
};
